import { useRef } from "react";
import { useScroll, useTransform, useReducedMotion } from "motion/react";

// Two-layer scroll parallax for a single section: a slower-moving background
// layer and a faster-moving foreground layer, per PARALLAX-SCROLL-SKILL.md's
// layered-depth technique. Capped at two layers (its own anti-pattern list
// flags more than 3-4), and fully disabled under reduced motion.
export function useSectionParallax() {
  const ref = useRef<HTMLDivElement>(null);
  const reduced = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const bgY = useTransform(scrollYProgress, [0, 1], reduced ? [0, 0] : [110, -110]);
  const fgY = useTransform(scrollYProgress, [0, 1], reduced ? [0, 0] : [40, -40]);
  return { ref, bgY, fgY };
}
